"use client";

import { useEffect } from "react";

/**
 * Filet de sécurité pour les invitations : si l'utilisateur atterrit sur la page
 * d'accueil avec un hash contenant access_token (ex. après un clic sur le mail
 * d'invitation), on le redirige vers /auth/set-password en conservant le hash
 * pour ne pas perdre la session.
 */
export function InviteHashRedirect() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash || "";
    const hasAccessToken = hash.includes("access_token=");
    const isInvite = hash.includes("type=invite") || hash.includes("type%3Dinvite");
    if (hasAccessToken && (isInvite || hash.includes("refresh_token="))) {
      window.location.replace(`${window.location.origin}/auth/set-password${hash}`);
    }
  }, []);

  return null;
}
